export default "__VITE_ASSET__KsfZRORt__"